/* tslint:disable */
/* eslint-disable */
/**
 * Indices API
 * Référentiel des indices de branche et de leurs valeurs datées
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GarantieDeriveeBrancheDto } from './GarantieDeriveeBrancheDto';
import {
    GarantieDeriveeBrancheDtoFromJSON,
    GarantieDeriveeBrancheDtoFromJSONTyped,
    GarantieDeriveeBrancheDtoToJSON,
    GarantieDeriveeBrancheDtoToJSONTyped,
} from './GarantieDeriveeBrancheDto';

/**
 * Branche du référentiel.
 * @export
 * @interface BrancheDto
 */
export interface BrancheDto {
    /**
     * 
     * @type {string}
     * @memberof BrancheDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BrancheDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BrancheDto
     */
    libelle?: string | null;
    /**
     * Calcul des primes dérivées (Cat Nat, Cat Tech, Attentat) activé sur la branche. Désactivé, le rôle des garanties est ignoré et leurs formules de tunnel s'appliquent.
     * @type {boolean}
     * @memberof BrancheDto
     */
    derivedPremiumsEnabled: boolean;
    /**
     * Taux de la prime Cat Nat, en pourcentage de l'assiette (20 = 20 %).
     * @type {number}
     * @memberof BrancheDto
     */
    catNatRate: number;
    /**
     * Taux de la prime Cat Tech, en pourcentage de l'assiette.
     * @type {number}
     * @memberof BrancheDto
     */
    catTechRate: number;
    /**
     * Taux de la prime Attentat, en pourcentage de l'assiette.
     * @type {number}
     * @memberof BrancheDto
     */
    attackRate: number;
    /**
     * Garanties de la branche qui portent un rôle de prime dérivée (au plus une par rôle).
     * @type {Array<GarantieDeriveeBrancheDto>}
     * @memberof BrancheDto
     */
    derivedGuarantees: Array<GarantieDeriveeBrancheDto>;
}

/**
 * Check if a given object implements the BrancheDto interface.
 */
export function instanceOfBrancheDto(value: object): value is BrancheDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('derivedPremiumsEnabled' in value) || value['derivedPremiumsEnabled'] === undefined) return false;
    if (!('catNatRate' in value) || value['catNatRate'] === undefined) return false;
    if (!('catTechRate' in value) || value['catTechRate'] === undefined) return false;
    if (!('attackRate' in value) || value['attackRate'] === undefined) return false;
    if (!('derivedGuarantees' in value) || value['derivedGuarantees'] === undefined) return false;
    return true;
}

export function BrancheDtoFromJSON(json: any): BrancheDto {
    return BrancheDtoFromJSONTyped(json, false);
}

export function BrancheDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrancheDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'libelle': json['libelle'] == null ? undefined : json['libelle'],
        'derivedPremiumsEnabled': json['derivedPremiumsEnabled'],
        'catNatRate': json['catNatRate'],
        'catTechRate': json['catTechRate'],
        'attackRate': json['attackRate'],
        'derivedGuarantees': ((json['derivedGuarantees'] as Array<any>).map(GarantieDeriveeBrancheDtoFromJSON)),
    };
}

export function BrancheDtoToJSON(json: any): BrancheDto {
    return BrancheDtoToJSONTyped(json, false);
}

export function BrancheDtoToJSONTyped(value?: BrancheDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'libelle': value['libelle'],
        'derivedPremiumsEnabled': value['derivedPremiumsEnabled'],
        'catNatRate': value['catNatRate'],
        'catTechRate': value['catTechRate'],
        'attackRate': value['attackRate'],
        'derivedGuarantees': ((value['derivedGuarantees'] as Array<any>).map(GarantieDeriveeBrancheDtoToJSON)),
    };
}

